<template>
    <div>
        <div
            class="btn-group mr-3"
            role="group">
            <button
                class="btn btn-light btn-filter-product d-flex align-items-center"
                :class="{ 'is-loading': isLoading }"
                :disabled="isLoading"
                @click="openFilterProduct"
            >
                <i class="material-icons filter-list-icon">filter_list</i>
                <span v-if="selectedProducts && selectedProducts.length > 0">
                    {{ selectedProducts.length }} Products Selected
                </span>
                <span v-else>Filter Products</span>
            </button>
            <button
                class="btn btn-light btn-filter-product"
                v-if="selectedProducts && selectedProducts.length > 0"
                @click="clearAll"
            >
                <i class="material-icons filter-list-icon">clear_all</i>
                <span>{{ $t('Clear All') }}</span>
            </button>
        </div>
        <div class="modals">
            <modal-filter-product
                :show="isModalFilterProductVisible"
                :selected-products="selectedProducts"
                @remove-item="removeItemsProduct"
                @close="closeFilterProduct"
                @input="onSelectProducts"
                @apply="applyFilterProducts"
            />
        </div>
    </div>
    </template>

<script>
const ModalFilterProduct = () => import(/* webpackChunkName: "modal-filter-product" */ '@/components/ModalFilterProduct.vue');

export default {
	name: 'FilterProduct',
	components: {
		ModalFilterProduct,
	},
	props: {
		mode: {
			type: String,
			default: '',
		},
	},

	data: () => ({
		isLoading: false,
		isModalFilterProductVisible: false,
		productIds: [],
		selectedProducts: [],
	}),

	methods: {
		openFilterProduct() {
			this.isModalFilterProductVisible = true;
			this.$emit('set-filter-product', this.isModalFilterProductVisible);
			// this.isLoading = true;
			// setTimeout(() => {
			// 	this.isLoading = false;
			// }, 500);
		},
		closeFilterProduct() {
			this.isModalFilterProductVisible = false;
			this.$emit('set-filter-product', this.isModalFilterProductVisible);
		},
		removeItemsProduct(id) {
			const index = this.selectedProducts.findIndex(item => item._id === id);
			this.selectedProducts.splice(index, 1);
		},
		onSelectProducts(products) {
			this.selectedProducts = products;
			this.$emit('select-products', this.selectedProducts);
		},
		applyFilterProducts() {
			const mapper = product => product?._id?.$oid;
			const productIds = this.selectedProducts.map(mapper) ?? [];
			this.$emit('apply', productIds);
			this.isModalFilterProductVisible = false;
		},
		clearAll() {
			this.selectedProducts = [];
			this.applyFilterProducts();
		},
	},
};
</script>
